import { useFlags } from 'launchdarkly-react-client-sdk';
import { useFeatureFlagRedirect } from 'hooks/useFeatureFlagRedirect';
import Dashboard from 'components/Dashboard/Dashboard';

export interface DashboardRouteProps {
  location?: unknown;
  navigate?: unknown;
}

/**
 * Route wrapper for the legacy dashboard.
 *
 * When the `enableDashboardRedesign` flag is on, redirects to the
 * liscio-frontend dashboard (`/dashboard/home`) using the shared migrated-page
 * redirect hook (same convention as smart-tax / requests). The frontend path
 * differs from the refactor path (`/dashboard`), hence the explicit
 * redirectPath. When the flag is off, the legacy Dashboard renders.
 */
export default function DashboardRoute({
  location,
  navigate,
}: DashboardRouteProps) {
  const { enableDashboardRedesign } = useFlags();

  const { uiReady } = useFeatureFlagRedirect({
    redirectPath: '/dashboard/home',
    isEnabled: enableDashboardRedesign,
  });

  if (!uiReady) {
    return null;
  }

  return <Dashboard location={location} navigate={navigate} />;
}
